<template>
<div>
    <div v-for="(v, i) in value" :key="i">
        <h5>Case: {{v.shortname}}</h5>
        <label for="condition">Condition for entering the case. Doesn't have to be unique.</label>
            <v-text-field hide-details="auto" id="condition" v-model="v.condition" />
        <hr/>
    </div>
</div>
</template>

<script>
export default {
    name: 'EditCases',
    props: ['value','item','conf'],
    computed: {
        items: {
            get: function () {
                return this.value;
            },
            set: function (newvalue) {
                this.$emit('input', newvalue);
            }
        }
    },
}
</script>
